import Vue from "vue";
import VueI18n from "vue-i18n";
import { languages } from '@/i18n/index.js';

Vue.use(VueI18n);

const messages = Object.assign(languages);
const dateTimeFormats = {
  fr: {
    short: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    long: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  }
};

const i18n = new VueI18n({
  locale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  fallbackLocale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  messages,
  dateTimeFormats,
});

export default i18n;
